/* eslint-disable complexity, sonarjs/cognitive-complexity, react-hooks/exhaustive-deps */
import find from 'lodash/find';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import ReactCookies from 'react-cookies';
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import { Element } from 'react-scroll';
import {
  BRAINTREE,
  COOKIES,
  PAYMENT_ELEMENT_NAME,
  PAYMENT_TYPES,
} from '../../../brands/default/constants';
import {
  PAYMENT,
  ERROR_USING_PAYPAL_AND_WALLET,
  PAYMENT_ADDRESS_MESSAGE,
  PAYMENT_ADDRESS_MESSAGE_POSTCODE,
  PAYMENT_LOGIN_MESSAGE,
  PAYMENT_NO_PURCHASABLE_MESSAGE,
  PAYMENT_PASSENGER_DETAILS_MESSAGE,
} from '../../../brands/default/content/components/checkout';
import { EIR_POSTCODE, WISHLIST } from '../../../brands/default/features';
import { LINK_HOME, LINK_SECOND_CHECKOUT } from '../../../brands/default/links';
import abandonmentService from '../../../helpers/abandonmentService';
import {
  trackEvent,
  trackUnbxdOrderEvent,
  updateDod,
} from '../../../helpers/analytics';
import BraintreeService from '../../../helpers/braintreeService';
import {
  getGiftPackDetails,
  getGiftWrapFromProducts,
} from '../../../helpers/checkout';
import { setCookie } from '../../../helpers/cookieSetter';
import ErrorTrackingService from '../../../helpers/errorTrackingService';
import {
  checkDefaultMethod,
  isSubscriptionAllowedByOptInType,
  choosePaymentTypeTracking,
  getGateway,
  getWalletCreditsVOForCurrency,
  isApplePayEnabled,
  isGooglePayEnabled,
  showKlarna,
} from '../../../helpers/payment';
import { paymentActionTypeHandler } from '../../../helpers/paymentErrorHandler';
import TravelService from '../../../helpers/travelService';
import { redirectToURL } from '../../../helpers/url';
import { trackNewVouchers } from '../../../helpers/vouchers';
import wait from '../../../helpers/wait';
import PurchaseContext from '../../../providers/PurchaseProvider';
import {
  emptyBasketProducts,
  removeProductFromBasket,
} from '../../../redux/actions/basket';
import { setCheckoutStatus } from '../../../redux/actions/checkout';
import {
  getWishlist,
  removeMultipleDeals,
} from '../../../redux/actions/wishlist';
import { CHECKOUT_STATUS } from '../../../redux/reducers/checkout';
import DisabledComponent from '../../_generic/DisabledComponent';
import Message from '../../_generic/Message';
import { logToSplunk } from '../../_generic/axiosSplunk/axiosSplunk';
import Spinner from '../../_generic/spinner/Spinner';
import Tile from '../../_generic/tile/Tile';
import TileBody from '../../_generic/tile/TileBody';
import useToast from '../../_generic/toast/UseToast';
import PaymentApple from './PaymentApple';
import PaymentCardBT from './PaymentCardBT';
import PaymentClearpay from './PaymentClearpay';
import PaymentErrors from './PaymentErrors';
import PaymentGoogle from './PaymentGoogle';
import PaymentKlarna from './PaymentKlarna';
import PaymentPaypal from './PaymentPaypal';
import PaymentSavedCardBT from './PaymentSavedCardBt';
import PaymentTypeButtons from './PaymentTypeButtons';
import VipPostButtonMessage from './VipPostButtonMessage';
import VipPreButtonMessage from './VipPreButtonMessage';
import VipSubscriptionMessage from './VipSubscriptionMessage';

const Payment = ({
  afterErrorPayment,
  allPurchaseCapReached,
  atolProtected,
  basketDiscountForExistingVipUser,
  basketProducts,
  bt,
  checkoutData,
  creditBalances,
  currencySymbol,
  deviceFingerprintId,
  discountPercentage,
  finalOrderAmount,
  handlePaymentRequiresAddress,
  isAuthCheckFinished,
  isAuthenticated,
  isExclusiveProductInBasket,
  isFullAddressRequired,
  isModernVip,
  isPostcodeRequired,
  isVipUser,
  isWalletApplied,
  orderSummary,
  paymentType,
  setPaymentType,
  payFinalOrderAmount,
  paymentInstruments,
  promoCode,
  setPayFinalOrderAmount,
  setVipOptIn,
  status,
  threeDSCheckEnabled,
  totalQuantity,
  vipCheckboxEnabled,
  vipCurrency,
  vipOneYearPrice,
  vipOptIn = null,
  vipOptInBasketDiscount,
  vipOptInFinalOrderAmount,
  vipOptInType,
  vipSubscriptionDetails,
  vipSummary,
  welcomeVipEnabled,
}) => {
  const router = useRouter();
  const toast = useToast();
  const dispatch = useDispatch();
  const [useSavedCard, setUseSavedCard] = useState(true);
  const [hasSavedCard, setHasSavedCard] = useState(false);
  const [creditCardOptions, setCreditCardOptions] = useState(null);
  const [isCardCheckDone, setIsCardCheckDone] = useState(false);
  const [errorObject, setErrorObject] = useState('');
  const giftWrapPreset = useSelector((state) => state.checkout.giftWrapPreset);
  const giftWrap = getGiftWrapFromProducts(basketProducts);
  const [isTravel, isTravelValid] = useSelector((state) => [
    state.checkout.isTravel,
    state.checkout.isTravelValid,
  ]);
  const wishlist = useSelector((state) => state.wishlist.wishlist);
  const isVipFromLightbox = ReactCookies.load(COOKIES.lightboxVip) === 'true';
  const gatewayValue = getGateway(paymentInstruments);
  const showBraintree = isAuthenticated && gatewayValue === BRAINTREE;
  const creditAmount = vipSummary?.vipOptInSubscription?.creditAmount;
  const [, setOrderId] = useContext(PurchaseContext);
  const [extraMerchantData, setExtraMerchantData] = useState(null);
  const [vipSubscriptionMessageComponent, setVipSubscriptionMessageComponent] =
    useState(null);

  useEffect(() => {
    logToSplunk(
      {
        checkoutData,
        component: 'Payment',
        finalOrderAmount,
        isWalletApplied,
        orderSummary,
        payFinalOrderAmount,
        type: 'checkout data in the payment component - on load',
        vipOptInFinalOrderAmount,
      },
      'frontend logs',
    );
  }, [checkoutData]);

  const handleSetVipOptIn = (vipOptInValue) => {
    const amountToPay = vipOptInValue
      ? vipOptInFinalOrderAmount
      : finalOrderAmount;
    BraintreeService.totalAmountToPay = amountToPay;
    BraintreeService.vipOptIn = vipOptInValue;
    setVipOptIn(vipOptInValue);
    setPayFinalOrderAmount(amountToPay);
  };

  const switchToNewCard = () => {
    setUseSavedCard(false);
  };

  const switchToSavedCard = () => {
    setUseSavedCard(true);
  };

  const choosePaymentType = (type) => {
    setPaymentType(type);
    handlePaymentRequiresAddress(
      type === PAYMENT_TYPES.klarna || type === PAYMENT_TYPES.clearpay,
    );
    choosePaymentTypeTracking(type);
    // only for reset of radio button flow
    if (welcomeVipEnabled) setVipOptIn(null);
  };

  const handleOrderComplete = async (order) => {
    dispatch(setCheckoutStatus(CHECKOUT_STATUS.UPDATING));
    const customerToken = ReactCookies.load(COOKIES.customerToken);
    abandonmentService.triggerBasketAbandon(
      customerToken,
      checkoutData,
      true,
      'update',
      order?.data?.productOrder?.id,
    );
    // Loop through the array and check for the desired property
    basketProducts.forEach((product) => {
      if (product.vipDiscounted === true) {
        // VIP Marketing discount purchases
        updateDod({
          dealId: product?.dealId,
          orderValue: product?.finalDealOrderAmount,
          Page_name: 'hub',
        });
        trackEvent('viphub: mcdeal buy');
        trackEvent('viphub: mcdeal rev');
      }
      if (product.vipExclusive === true) {
        updateDod({
          dealId: product?.dealId,
          orderValue: product?.finalDealOrderAmount,
          Page_name: 'hub',
        });
        trackEvent('viphub: exclusive buy');
        trackEvent('viphub: exclusive rev');
      }
      if (product.earlyBird === true) {
        updateDod({
          dealId: product?.dealId,
          orderValue: product?.finalDealOrderAmount,
          Page_name: 'hub',
        });
        trackEvent('viphub: eb buy');
        trackEvent('viphub: eb rev');
      }
    });
    if (isTravel) {
      try {
        await TravelService.instantRedeem(order?.data?.productOrder?.id);
      } catch (error) {
        console.error(error);
      }
    }
    await dispatch(removeMultipleDeals(checkoutData.deals, wishlist));
    await emptyBasketProducts(bt);

    const CheckoutOrder = {
      deals: checkoutData.deals,
      hasNewOrder: true,
      orderId: order?.data?.productOrder?.id,
      products: basketProducts,
    };

    trackUnbxdOrderEvent(CheckoutOrder);
    trackNewVouchers(CheckoutOrder);

    await wait(2_000); // delay to give time for tracking to fire

    dispatch(setCheckoutStatus(CHECKOUT_STATUS.READY));

    setOrderId(order?.data?.productOrder?.id);

    const orderIdFromAPI =
      order?.data?.productOrder?.id || order?.productOrder?.id;

    if (isVipFromLightbox) {
      setCookie({
        expire: 365,
        key: COOKIES.lightboxVip,
        value: false,
      });
      redirectToURL(LINK_HOME, router);
    } else {
      redirectToURL(
        `${LINK_SECOND_CHECKOUT}/benefits/${orderIdFromAPI}`,
        router,
      );
    }
  };

  const afterError = () => {
    afterErrorPayment();
  };

  const providerError = (error) => {
    setErrorObject(error);
  };

  const customError = (errors) => {
    for (const error of errors) {
      const product = basketProducts.find(({ id }) => id === error.productId);
      if (product) {
        // clear the product from the basket
        if (product.gifting.giftPackProductId) {
          const addedGiftPack = getGiftPackDetails(
            checkoutData.deals,
            product.gifting.giftPackProductId,
          );
          dispatch(
            removeProductFromBasket(
              bt,
              product,
              addedGiftPack,
              giftWrap || giftWrapPreset,
            ),
          );
        } else {
          dispatch(removeProductFromBasket(bt, product, null, giftWrap));
        }
      }
    }
  };

  const getSavedCards = async () => {
    try {
      return await BraintreeService.getVaultedCards();
    } catch (error) {
      const message = error.message;

      return toast.addToast(message, 'toast-error', 'top-right');
    }
  };

  useEffect(() => {
    if (WISHLIST) dispatch(getWishlist());
  }, [dispatch, isAuthenticated]);

  const isPostage = checkoutData.orderSummary?.postageOnRedemption;

  useEffect(() => {
    // use value only for a flow of wvux
    if (vipCheckboxEnabled) {
      setPayFinalOrderAmount(vipOptInFinalOrderAmount);
      BraintreeService.vipOptIn = vipOptIn;
    } else if (!vipCheckboxEnabled && !welcomeVipEnabled) {
      setPayFinalOrderAmount(finalOrderAmount);
      BraintreeService.vipOptIn = false;
    }

    BraintreeService.vipOptInType = vipOptInType;
    BraintreeService.totalAmountToPay = payFinalOrderAmount;
    BraintreeService.isRedeemPostage = isPostage;
    BraintreeService.vipSubscriptionDetails = vipSubscriptionDetails;
    BraintreeService.orderSummaryIdentifier =
      checkoutData?.orderSummary?.orderSummaryIdentifier;
    BraintreeService.basketDiscountForExistingVipUser =
      basketDiscountForExistingVipUser;
    BraintreeService.vipOptInBasketDiscount =
      vipSummary?.vipOptInSubscription?.vipOptInBasketDiscount;
    if (promoCode?.value && promoCode?.applicable) {
      BraintreeService.promoCode = promoCode.value;
    } else {
      BraintreeService.promoCode = null;
    }
  }, [
    basketDiscountForExistingVipUser,
    finalOrderAmount,
    isPostage,
    payFinalOrderAmount,
    promoCode,
    vipOptIn,
    vipOptInFinalOrderAmount,
    vipOptInType,
  ]);

  useEffect(() => {
    const currency = orderSummary && orderSummary?.currency;
    if (currency) {
      const walletsVO = getWalletCreditsVOForCurrency(creditBalances, currency);
      BraintreeService.walletCreditsVO = walletsVO;
    }
  }, [creditBalances]);

  useEffect(() => {
    BraintreeService.deviceFingerprintId = deviceFingerprintId;
  }, [deviceFingerprintId]);

  useEffect(() => {
    if (
      paymentInstruments?.length === 0 &&
      !creditBalances &&
      isAuthenticated
    ) {
      ErrorTrackingService.logError({
        error: 'Empty paymentInstruments',
        message: 'Checkout is returning no payment methods for the user.',
      });
    }
    if (paymentInstruments && paymentInstruments.length > 0) {
      if (showBraintree) {
        const setCards = async () => {
          const cards = await getSavedCards();
          if (cards?.length && !creditCardOptions) {
            setCreditCardOptions({ cards });
            setHasSavedCard(true);
            setIsCardCheckDone(true);
          }
        };
        setCards();
      }
      const defaultInstrument = find(paymentInstruments, { default: 'yes' });
      if (!paymentType && paymentInstruments !== null) {
        choosePaymentType(
          checkDefaultMethod({
            basketProducts,
            finalOrderAmount,
            isAuthenticated,
            paymentInstruments,
            type: defaultInstrument?.type,
          }) || PAYMENT_TYPES.card,
        );
      }
      if (get(defaultInstrument, 'default', false)) {
        const newType =
          errorObject &&
          paymentActionTypeHandler({
            action: errorObject.action,
            paypalToken:
              find(paymentInstruments, {
                type: PAYMENT_TYPES.paypal,
              })?.durableToken === 'yes',
            savedCard: hasSavedCard,
            type: paymentType,
          });
        if (newType.type) {
          choosePaymentType(newType.type);
          if (newType.emptyForm) setUseSavedCard(false);
        }
      }
    }
    setTimeout(() => {
      if (!isCardCheckDone) {
        setIsCardCheckDone(true);
      }
    }, 5_000);
  }, [paymentInstruments, finalOrderAmount, isAuthenticated]);

  const setPaymentTypeToCard = useCallback(() => {
    if (paymentType === PAYMENT_TYPES.card) {
      return;
    }
    choosePaymentType(PAYMENT_TYPES.card);
  }, [paymentType]);

  useEffect(() => {
    if (finalOrderAmount === 0) {
      setPaymentTypeToCard();
    }
  }, [setPaymentTypeToCard, finalOrderAmount]);

  useEffect(() => {
    if (
      basketProducts.length &&
      finalOrderAmount &&
      paymentInstruments &&
      paymentInstruments.length > 0 &&
      isAuthenticated
    ) {
      const foundKlarna = Boolean(
        showKlarna({
          basketProducts,
          finalOrderAmount,
          isAuthenticated,
          paymentInstruments,
        }),
      );
      trackEvent(foundKlarna ? 'klarna_enabled' : 'klarna_disabled');

      const foundClearpay = Boolean(
        showKlarna({
          basketProducts,
          finalOrderAmount,
          isAuthenticated,
          paymentInstruments,
        }),
      );
      trackEvent(foundClearpay ? 'clearpay_enabled' : 'clearpay_disabled');
    }

    setExtraMerchantData(
      showKlarna({
        basketProducts,
        finalOrderAmount,
        isAuthenticated,
        paymentInstruments,
      })?.details || null,
    );
  }, [basketProducts, finalOrderAmount, isAuthenticated, paymentInstruments]);

  const getVipPreButtonMessage = () => {
    if (!welcomeVipEnabled || isVipUser) {
      return null;
    }

    const discount = vipSummary?.vipOptInSubscription?.vipOptInBasketDiscount;
    const months = vipSummary?.vipOptInSubscription?.vipOptInValidity;
    const timeUnit = vipSummary?.vipOptInSubscription?.timeUnit;
    const isFreeSubTrial = vipOptInType?.includes('VIP-SUB-FREE-TRIAL');

    if (!discount || !months) {
      return null;
    }

    return (
      <VipPreButtonMessage
        currencySymbol={currencySymbol}
        discount={discount}
        discountPercentage={discountPercentage}
        isFreeSubTrial={isFreeSubTrial}
        isModernVip={isModernVip}
        months={months}
        timeUnit={timeUnit}
        vipOptInBasketDiscount={vipOptInBasketDiscount}
        vipOptInType={vipOptInType}
      />
    );
  };

  const getVipSubscriptionMessageComponent = () => {
    console.log('getVipSubscriptionMessageComponent =======');
    console.log(isVipUser);
    console.log(vipOptInType);
    if (isVipUser) {
      return null;
    }

    const isSubscriptionAllowed = isSubscriptionAllowedByOptInType({
      vipOptInType,
    });
    console.log(isSubscriptionAllowed);

    if (isSubscriptionAllowed) {
      let renewalDate = vipSummary?.vipOptInSubscription?.vipRenewalDate;
      if (isModernVip) {
        renewalDate =
          orderSummary?.paymentTypeVipSummary[paymentType]?.vipOptInSubscription
            ?.vipRenewalDate;
      }

      return (
        <VipSubscriptionMessage
          quarterlySubEnabled={
            vipSummary?.vipOptInSubscription?.quarterlySubEnabled
          }
          renewalDate={renewalDate}
          vipComplianceText={vipSubscriptionDetails.vipComplianceText}
          vipCurrency={vipCurrency}
          vipMonths={12}
          vipPrice={vipOneYearPrice}
          vipQuarterlyPrice={vipSubscriptionDetails?.quarterlyPrice}
        />
      );
    }

    return null;
  };

  useEffect(() => {
    if (paymentInstruments && paymentInstruments?.length > 0 && paymentType) {
      setVipSubscriptionMessageComponent(getVipSubscriptionMessageComponent());
    }
  }, [paymentType, paymentInstruments, vipOptInType]);

  if (!(basketProducts && basketProducts.length > 0)) return null;

  return (
    <>
      {status !== CHECKOUT_STATUS.READY && <Spinner hasMsg={false} />}
      <Tile extraClasses="payment" title={PAYMENT}>
        <TileBody nobackground>
          <Element name={PAYMENT_ELEMENT_NAME} />
          <DisabledComponent
            isDisabled={
              !isAuthenticated ||
              isFullAddressRequired ||
              (!EIR_POSTCODE && isPostcodeRequired)
            }
          />
          <PaymentTypeButtons
            basketProducts={basketProducts}
            choosePaymentType={choosePaymentType}
            finalOrderAmount={finalOrderAmount}
            isAuthenticated={isAuthenticated}
            paymentInstruments={paymentInstruments}
            paymentType={paymentType}
          />
          {isTravel && !isTravelValid && (
            <Message
              extraClasses="passenger-details-to-purchase"
              message={PAYMENT_PASSENGER_DETAILS_MESSAGE}
            />
          )}
          {isFullAddressRequired && (
            <Message
              extraClasses="login-to-purchase"
              message={PAYMENT_ADDRESS_MESSAGE}
            />
          )}
          {!EIR_POSTCODE && isPostcodeRequired && (
            <Message
              extraClasses="login-to-purchase"
              message={PAYMENT_ADDRESS_MESSAGE_POSTCODE}
            />
          )}
          {!isAuthenticated && (
            <Message
              extraClasses="login-to-purchase"
              message={PAYMENT_LOGIN_MESSAGE}
            />
          )}
          {isAuthenticated && !isCardCheckDone && <Spinner />}
          {isAuthenticated && allPurchaseCapReached && (
            <Message message={PAYMENT_NO_PURCHASABLE_MESSAGE} />
          )}
          {errorObject.message && (
            <PaymentErrors message={errorObject.message} />
          )}
          {finalOrderAmount === 0 && (
            <Message message={ERROR_USING_PAYPAL_AND_WALLET} />
          )}
          {paymentType === PAYMENT_TYPES.card &&
            isAuthCheckFinished &&
            isAuthenticated &&
            (!hasSavedCard || !useSavedCard) &&
            isCardCheckDone && (
              <PaymentCardBT
                afterError={afterError}
                atolProtected={atolProtected}
                basketProducts={basketProducts}
                checkoutData={checkoutData}
                currencySymbol={currencySymbol}
                finalOrderAmount={finalOrderAmount}
                hasSavedCard={hasSavedCard}
                isExclusiveProductInBasket={isExclusiveProductInBasket}
                isVipUser={isVipUser}
                isWalletApplied={isWalletApplied}
                orderComplete={handleOrderComplete}
                orderSummary={orderSummary}
                paymentInstruments={paymentInstruments}
                providerError={providerError}
                switchToSavedCard={switchToSavedCard}
                threeDSCheckEnabled={threeDSCheckEnabled}
                totalQuantity={totalQuantity}
                travelDisableButton={isTravel && !isTravelValid}
                vipOptIn={vipOptIn}
                vipOptInFinalOrderAmount={vipOptInFinalOrderAmount}
                vipPreButtonMessage={getVipPreButtonMessage()}
                vipSubscriptionMessage={vipSubscriptionMessageComponent}
                welcomeVipEnabled={welcomeVipEnabled}
              />
            )}
          {paymentType === PAYMENT_TYPES.card &&
            !isEmpty(paymentInstruments) &&
            hasSavedCard &&
            isCardCheckDone &&
            useSavedCard && (
              <PaymentSavedCardBT
                afterError={afterError}
                atolProtected={atolProtected}
                basketProducts={basketProducts}
                checkoutData={checkoutData}
                creditCardOptions={creditCardOptions}
                currencySymbol={currencySymbol}
                customError={customError}
                finalOrderAmount={finalOrderAmount}
                isExclusiveProductInBasket={isExclusiveProductInBasket}
                isVipUser={isVipUser}
                isWalletApplied={isWalletApplied}
                orderComplete={handleOrderComplete}
                orderSummary={orderSummary}
                paymentInstruments={paymentInstruments}
                providerError={providerError}
                switchToNewCard={switchToNewCard}
                threeDSCheckEnabled={threeDSCheckEnabled}
                totalQuantity={totalQuantity}
                travelDisableButton={isTravel && !isTravelValid}
                vipOptIn={vipOptIn}
                vipOptInFinalOrderAmount={vipOptInFinalOrderAmount}
                vipPreButtonMessage={getVipPreButtonMessage()}
                vipSubscriptionMessage={vipSubscriptionMessageComponent}
                welcomeVipEnabled={welcomeVipEnabled}
              />
            )}
          {paymentType === PAYMENT_TYPES.paypal && (
            <PaymentPaypal
              afterError={afterError}
              atolProtected={atolProtected}
              basketProducts={basketProducts}
              checkoutData={checkoutData}
              currencySymbol={currencySymbol}
              customError={customError}
              finalOrderAmount={finalOrderAmount}
              isExclusiveProductInBasket={isExclusiveProductInBasket}
              isMobile={isMobile}
              isVipUser={isVipUser}
              isWalletApplied={isWalletApplied}
              orderComplete={handleOrderComplete}
              orderSummary={orderSummary}
              payFinalOrderAmount={payFinalOrderAmount}
              providerError={providerError}
              setVipOptIn={handleSetVipOptIn}
              totalQuantity={totalQuantity}
              travelDisableButton={isTravel && !isTravelValid}
              vipOptIn={vipOptIn}
              vipOptInFinalOrderAmount={vipOptInFinalOrderAmount}
              vipPreButtonMessage={getVipPreButtonMessage()}
              vipSubscriptionMessage={vipSubscriptionMessageComponent}
              welcomeVipEnabled={welcomeVipEnabled}
            />
          )}
          {paymentType === PAYMENT_TYPES.google && isGooglePayEnabled() && (
            <PaymentGoogle
              afterError={afterError}
              atolProtected={atolProtected}
              basketProducts={basketProducts}
              currencySymbol={currencySymbol}
              customError={customError}
              finalOrderAmount={finalOrderAmount}
              isExclusiveProductInBasket={isExclusiveProductInBasket}
              isMobile={isMobile}
              isVipUser={isVipUser}
              isWalletApplied={isWalletApplied}
              orderComplete={handleOrderComplete}
              orderSummary={orderSummary}
              payFinalOrderAmount={payFinalOrderAmount}
              providerError={providerError}
              setVipOptIn={handleSetVipOptIn}
              totalQuantity={totalQuantity}
              travelDisableButton={isTravel && !isTravelValid}
              vipOptIn={vipOptIn}
              vipOptInFinalOrderAmount={vipOptInFinalOrderAmount}
              vipPreButtonMessage={getVipPreButtonMessage()}
              vipSubscriptionMessage={vipSubscriptionMessageComponent}
              welcomeVipEnabled={welcomeVipEnabled}
            />
          )}
          {paymentType === PAYMENT_TYPES.apple && isApplePayEnabled() && (
            <PaymentApple
              afterError={afterError}
              atolProtected={atolProtected}
              basketProducts={basketProducts}
              currencySymbol={currencySymbol}
              customError={customError}
              finalOrderAmount={finalOrderAmount}
              isExclusiveProductInBasket={isExclusiveProductInBasket}
              isMobile={isMobile}
              isVipUser={isVipUser}
              isWalletApplied={isWalletApplied}
              orderComplete={handleOrderComplete}
              orderSummary={orderSummary}
              payFinalOrderAmount={payFinalOrderAmount}
              providerError={providerError}
              setVipOptIn={handleSetVipOptIn}
              totalQuantity={totalQuantity}
              travelDisableButton={isTravel && !isTravelValid}
              vipOptIn={vipOptIn}
              vipOptInFinalOrderAmount={vipOptInFinalOrderAmount}
              vipPreButtonMessage={getVipPreButtonMessage()}
              vipSubscriptionMessage={vipSubscriptionMessageComponent}
              welcomeVipEnabled={welcomeVipEnabled}
            />
          )}
          {paymentType === PAYMENT_TYPES.klarna && (
            <PaymentKlarna
              afterError={afterError}
              atolProtected={atolProtected}
              basketDiscountForExistingVipUser={
                basketDiscountForExistingVipUser
              }
              basketProducts={basketProducts}
              currencySymbol={currencySymbol}
              extraMerchantData={extraMerchantData}
              finalOrderAmount={finalOrderAmount}
              isExclusiveProductInBasket={isExclusiveProductInBasket}
              isMobile={isMobile}
              isModernVip={isModernVip}
              isVipUser={isVipUser}
              isWalletApplied={isWalletApplied}
              orderComplete={handleOrderComplete}
              orderSummary={orderSummary}
              payFinalOrderAmount={payFinalOrderAmount}
              promoCode={promoCode}
              setVipOptIn={handleSetVipOptIn}
              totalQuantity={totalQuantity}
              travelDisableButton={isTravel && !isTravelValid}
              vipOneYearPrice={vipOneYearPrice}
              vipOptIn={vipOptIn}
              vipOptInFinalOrderAmount={vipOptInFinalOrderAmount}
              vipOptInPrice={
                orderSummary?.vipSummary?.vipOptInSubscription?.vipOptInPrice
              }
              vipOptInType={vipOptInType}
              vipPreButtonMessage={getVipPreButtonMessage()}
              vipSubscriptionMessage={vipSubscriptionMessageComponent}
              vipSummary={vipSummary}
              welcomeVipEnabled={welcomeVipEnabled}
            />
          )}
          {paymentType === PAYMENT_TYPES.clearpay && (
            <PaymentClearpay
              afterError={afterError}
              atolProtected={atolProtected}
              basketDiscountForExistingVipUser={
                basketDiscountForExistingVipUser
              }
              basketProducts={basketProducts}
              currencySymbol={currencySymbol}
              deviceFingerprintId={deviceFingerprintId}
              finalOrderAmount={finalOrderAmount}
              isExclusiveProductInBasket={isExclusiveProductInBasket}
              isMobile={isMobile}
              isModernVip={isModernVip}
              isVipUser={isVipUser}
              isWalletApplied={isWalletApplied}
              orderComplete={handleOrderComplete}
              orderSummary={orderSummary}
              payFinalOrderAmount={payFinalOrderAmount}
              promoCode={promoCode}
              setVipOptIn={handleSetVipOptIn}
              totalQuantity={totalQuantity}
              travelDisableButton={isTravel && !isTravelValid}
              vipOptIn={vipOptIn}
              vipOptInFinalOrderAmount={vipOptInFinalOrderAmount}
              vipOptInType={vipOptInType}
              vipPreButtonMessage={getVipPreButtonMessage()}
              vipSubscriptionMessage={vipSubscriptionMessageComponent}
              vipSummary={vipSummary}
              welcomeVipEnabled={welcomeVipEnabled}
            />
          )}
          {!isVipUser && welcomeVipEnabled && (
            <VipPostButtonMessage
              creditAmount={creditAmount}
              currencySymbol={currencySymbol}
              discount={
                vipSummary?.vipOptInSubscription?.vipOptInBasketDiscount
              }
              vipOneYearCost={vipSubscriptionDetails?.price}
            />
          )}
        </TileBody>
      </Tile>
    </>
  );
};

Payment.propTypes = {
  afterErrorPayment: PropTypes.func.isRequired,
  allPurchaseCapReached: PropTypes.bool.isRequired,
  atolProtected: PropTypes.bool,
  basketDiscountForExistingVipUser: PropTypes.number,
  basketProducts: PropTypes.array.isRequired,
  bt: PropTypes.string,
  checkoutData: PropTypes.object.isRequired,
  creditBalances: PropTypes.any,
  currencySymbol: PropTypes.string,
  deviceFingerprintId: PropTypes.string,
  finalOrderAmount: PropTypes.number,
  handlePaymentRequiresAddress: PropTypes.func,
  isAuthCheckFinished: PropTypes.bool,
  isAuthenticated: PropTypes.bool.isRequired,
  isExclusiveProductInBasket: PropTypes.bool,
  isFullAddressRequired: PropTypes.bool,
  isPostcodeRequired: PropTypes.bool,
  isVipUser: PropTypes.bool,
  isWalletApplied: PropTypes.bool,
  orderSummary: PropTypes.object.isRequired,
  paymentInstruments: PropTypes.any,
  promoCode: PropTypes.object,
  setVipOptIn: PropTypes.func,
  status: PropTypes.string,
  subscriptionCardPaymentStatus: PropTypes.object,
  threeDSCheckEnabled: PropTypes.bool,
  totalQuantity: PropTypes.number.isRequired,
  vipCheckboxEnabled: PropTypes.bool,
  vipCurrency: PropTypes.string,
  vipLayout: PropTypes.string,
  vipOneYearPrice: PropTypes.number,
  vipOptIn: PropTypes.bool,
  vipOptInFinalOrderAmount: PropTypes.number,
  vipOptInType: PropTypes.string,
  vipSubscriptionDetails: PropTypes.object,
  vipSummary: PropTypes.object,
  welcomeVipEnabled: PropTypes.bool,
};

export default Payment;
